import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Contact\GetContactListController::__invoke
* @see app/Http/Controllers/Contact/GetContactListController.php
* @route '/api/contact'
*/
const GetContactListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetContactListController.url(options),
    method: 'get',
})

GetContactListController.definition = {
    methods: ["get","head"],
    url: '/api/contact',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Contact\GetContactListController::__invoke
* @see app/Http/Controllers/Contact/GetContactListController.php
* @route '/api/contact'
*/
GetContactListController.url = (options?: RouteQueryOptions) => {
    return GetContactListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Contact\GetContactListController::__invoke
* @see app/Http/Controllers/Contact/GetContactListController.php
* @route '/api/contact'
*/
GetContactListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetContactListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Contact\GetContactListController::__invoke
* @see app/Http/Controllers/Contact/GetContactListController.php
* @route '/api/contact'
*/
GetContactListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetContactListController.url(options),
    method: 'head',
})

export default GetContactListController